import './Findings.css';

// The finding card and severity order of the public shared-report page.

// Severity ordering for summary chips and findings sort.
export const SEVERITY_ORDER = ['critical', 'major', 'minor', 'info'];

function renderMessage(text) {
  const escaped = (text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
  const html = escaped.replace(/`([^`]+)`/g, '<code>$1</code>');
  return { __html: html };
}

export function FindingCard({ finding, findingId }) {
  const segIdx = finding.segment_index + 1;
  return (
    <div
      className={`qa-finding qa-finding-${finding.severity}`}
      id={findingId !== undefined ? `finding-${findingId}` : undefined}
      data-finding-id={findingId}
    >
      <div className="qa-finding-head">
        <span className={`qa-finding-severity qa-finding-severity-${finding.severity}`}>
          {finding.severity}
        </span>
        <code className="qa-finding-name">{finding.check_name}</code>
        <span className="qa-finding-mqm">
          {finding.mqm_category}
          {finding.mqm_subtype ? ` · ${finding.mqm_subtype}` : ''}
        </span>
        <span className="qa-finding-segment">segment #{segIdx}</span>
      </div>
      <div className="qa-finding-message" dangerouslySetInnerHTML={renderMessage(finding.message)} />
      {finding.suggestion && (
        <div className="qa-finding-suggestion" dangerouslySetInnerHTML={renderMessage(finding.suggestion)} />
      )}
    </div>
  );
}
